import { clearLocalStorage } from '@agilytics/utils';

export default async function fetch(...args) {
  const browserFetch = window.fetch;
  try {
    return await browserFetch(...args)
      .then(res => {
        if (!res.ok) {
          throw new FetchError(res.status, res.statusText);
        }
        return res;
      })
      .then(res => res.json());
  } catch (e) {
    handleFetchError(e);
  }
}

export class FetchError extends Error {
  constructor(status, ...rest) {
    super(rest);
    this.status = status;
  }
}

function handleFetchError(error) {
  const { status } = error;

  if (status === 401) {
    clearLocalStorage();
    window.history.pushState(null, null, '/');
    window.history.go();
  } else if ((!status || status >= 400) && !window.location.pathname.includes('/500')) {
    window.history.pushState(null, null, '/500');
    window.history.go();
  }
}
